import styles from './LoadingPage.module.css'
import { Spin } from 'antd'

function LoadingPage({ loadingMessage = false }) {
  return (
    <div className={styles.container}>
      <div className={styles.bloc}>
        <div className={styles.loading_content}>
          <div className={styles.logoname}>FORMA</div>

          {loadingMessage && (
            <div className={styles.patienter}>
              Merci de patienter, nous stockons votre réponse !
            </div>
          )}
        </div>

        <span className={styles.loader}></span>
      </div>
    </div>
  )
}

export default LoadingPage
